(() => {
  const namespace = window.HumanPrimeCatalogLive || {};
  if (namespace.initialized) {
    document.querySelectorAll('[data-live-catalog]').forEach((root) => namespace.init(root));
    return;
  }

  namespace.initialized = true;
  namespace.controllers = new WeakMap();

  const updateCartCount = (cart) => {
    const cartLink = document.querySelector('.site-header__icon-button--cart');
    if (!cartLink || !cart) return;

    let badge = cartLink.querySelector('.site-header__cart-count');
    if (cart.item_count > 0 && !badge) {
      badge = document.createElement('span');
      badge.className = 'site-header__cart-count';
      badge.setAttribute('aria-hidden', 'true');
      cartLink.append(badge);
    }
    if (badge) {
      badge.textContent = String(cart.item_count);
      badge.hidden = cart.item_count < 1;
    }

    let accessibleCount = cartLink.querySelector('[data-live-cart-count]');
    if (!accessibleCount) {
      accessibleCount = document.createElement('span');
      accessibleCount.className = 'hp-visually-hidden';
      accessibleCount.dataset.liveCartCount = '';
      cartLink.append(accessibleCount);
    }
    accessibleCount.textContent = `${cart.item_count} ${cart.item_count === 1 ? 'producto' : 'productos'} en el carrito`;
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
  };

  namespace.init = (root) => {
    if (!root || namespace.controllers.has(root)) return;

    const cards = Array.from(root.querySelectorAll('[data-live-product-card]'));
    if (!cards.length) return;

    const abortController = new AbortController();
    const signal = abortController.signal;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    let revealObserver = null;
    const frameIds = new Map();

    if (!reduceMotion && 'IntersectionObserver' in window) {
      root.classList.add('catalog-live--motion');
      revealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          revealObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
      cards.forEach((card) => revealObserver.observe(card));
    } else {
      cards.forEach((card) => card.classList.add('is-revealed'));
    }

    if (finePointer && !reduceMotion) {
      cards.forEach((card) => {
        card.addEventListener('pointermove', (event) => {
          if (frameIds.has(card)) cancelAnimationFrame(frameIds.get(card));
          const frameId = requestAnimationFrame(() => {
            const bounds = card.getBoundingClientRect();
            const horizontal = (event.clientX - bounds.left) / bounds.width - 0.5;
            const vertical = (event.clientY - bounds.top) / bounds.height - 0.5;
            card.style.setProperty('--card-tilt-x', `${(-vertical * 4).toFixed(2)}deg`);
            card.style.setProperty('--card-tilt-y', `${(horizontal * 4).toFixed(2)}deg`);
            frameIds.delete(card);
          });
          frameIds.set(card, frameId);
        }, { signal, passive: true });

        card.addEventListener('pointerleave', () => {
          card.style.setProperty('--card-tilt-x', '0deg');
          card.style.setProperty('--card-tilt-y', '0deg');
        }, { signal, passive: true });
      });
    }

    root.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-card-quick-add]');
      if (!form || !root.contains(form)) return;
      event.preventDefault();

      const button = form.querySelector('[data-card-add-button]');
      const label = form.querySelector('[data-card-add-label]');
      const card = form.closest('[data-live-product-card]');
      const status = card?.querySelector('[data-card-status]');
      if (!button || button.disabled) return;

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      label.textContent = 'Agregando…';
      if (status) {
        status.textContent = '';
        status.classList.remove('is-error');
      }

      try {
        const response = await fetch(`${form.action}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'No se pudo agregar el producto.');

        const cartResponse = await fetch(form.dataset.cartUrl, { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error('El producto se agregó, pero no se pudo actualizar el contador.');
        const cart = await cartResponse.json();
        updateCartCount(cart);
        label.textContent = 'Agregado ✓';
        if (status) status.textContent = 'Producto agregado al carrito.';
        window.setTimeout(() => {
          if (label.isConnected) label.textContent = 'Agregar';
          if (button.isConnected) button.disabled = false;
        }, 1800);
      } catch (error) {
        label.textContent = 'Agregar';
        button.disabled = false;
        if (status) {
          status.textContent = error.message || 'No se pudo agregar el producto.';
          status.classList.add('is-error');
        }
      } finally {
        button.removeAttribute('aria-busy');
      }
    }, { signal });

    namespace.controllers.set(root, {
      destroy() {
        abortController.abort();
        revealObserver?.disconnect();
        frameIds.forEach((frameId) => cancelAnimationFrame(frameId));
        frameIds.clear();
      }
    });
  };

  namespace.destroy = (root) => {
    const controller = namespace.controllers.get(root);
    if (!controller) return;
    controller.destroy();
    namespace.controllers.delete(root);
  };

  window.HumanPrimeCatalogLive = namespace;
  document.querySelectorAll('[data-live-catalog]').forEach((root) => namespace.init(root));

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.matches?.('[data-live-catalog]') ? event.target : event.target.querySelector?.('[data-live-catalog]');
    namespace.init(root);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.matches?.('[data-live-catalog]') ? event.target : event.target.querySelector?.('[data-live-catalog]');
    namespace.destroy(root);
  });
})();
